<template>
  <div>
    <form @submit.prevent>
      <div class="row d-flex m-0">
        <div class="form-title flex-1-0">Danh sách vai trò</div>
        <b-form-group class="">
          <div class="d-flex">
            <div
              class=""
              v-if="!readonly && chiTietNguoiDung.userCanBoDepartmentId"
            >
              <base-button
                class="btn search-information-btn d-block mr-2"
                button="Thêm vai trò"
                v-if="
                  hasPermissionUser(PERMISSION_NAME.VAI_TRO.THEM_NGUOI_DUNG)
                "
                @click="moFormThemDanhSachVaiTro()"
              >
                Thêm vai trò
              </base-button>
              <base-button
                :disabled="selectedVaiTro.length === 0"
                class="btn search-information-btn d-block"
                v-if="hasPermissionUser(PERMISSION_NAME.VAI_TRO.XOA_NGUOI_DUNG)"
                button="Xóa vai trò đã chọn"
                @click="moFormXoaDanhSachVaiTro()"
              >
                Xóa vai trò đã chọn
              </base-button>
            </div>
          </div>
        </b-form-group>
      </div>
      <div class="box-form-result">
        <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
        <DataTable
          :loading="isLoadingTable"
          :value="danhSachVaiTroNoiBo"
          dataKey="id"
          :selection.sync="selectedVaiTro"
          class="p-datatable-customers"
        >
          <template #empty
            ><div class="text-center">Không có dữ liệu</div></template
          >
          <template #loading
            ><div class="text-center">Đang tải dữ liệu ...</div>
          </template>
          <Column
            v-if="!readonly"
            field="id"
            headerStyle="width: 40px"
            header=""
            bodyStyle="text-align: center"
            selectionMode="multiple"
          >
          </Column>
          <Column
            field="stt"
            dataKey="stt"
            headerStyle="width: 40px"
            headerClass="p-2"
            header="STT"
            bodyStyle="text-align: center"
          >
            <template #filter> </template>
            <template #body="slotProps">
              <span>{{
                (requestInformation.pageIndex - 1) *
                  requestInformation.pageSize +
                slotProps.index +
                1
              }}</span>
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="name"
            header="Tên vai trò"
            headerStyle="minWidth: 200px"
          >
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestInternalForm.Name"
                @change="layDanhSachVaiTro"
              />
            </template>
            <template #body="slotProps">
              <span>{{ slotProps.data.name }}</span>
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="displayName"
            header="Tên hiển thị"
            headerStyle="minWidth: 200px"
          >
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestInternalForm.DisplayName"
                @change="layDanhSachVaiTro"
              />
            </template>
            <template #body="slotProps">
              <span>{{ slotProps.data.displayName }}</span>
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="appName"
            header="Ứng dụng"
            headerStyle="minWidth: 200px"
          >
            <template #filter>
              <InputText
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="requestInternalForm.AppName"
                @change="layDanhSachVaiTro"
              />
            </template>
            <template #body="slotProps">
              <div v-html="slotProps.data.appName"></div>
            </template>
          </Column>
          <Column
            filterMatchMode="custom"
            field="thaoTac"
            header="Thao tác"
            headerStyle="width: 100px"
            v-if="
              !readonly &&
              hasPermissionUser(PERMISSION_NAME.VAI_TRO.XOA_NGUOI_DUNG)
            "
          >
            <template #body="slotProps">
              <div class="text-center">
                <font-awesome-icon
                  icon="trash-alt"
                  v-b-popover.hover.top="'Xóa vai trò'"
                  class="cursor-pointer color-red ml-2"
                  @click="moFormXoaVaiTro(slotProps.data.id)"
                />
              </div>
            </template>
          </Column>
        </DataTable>
        <BasePagination
          class="mt-3"
          :current-page="requestInformation.pageIndex"
          :total-pages="totalPages"
          :total-rows="totalRows"
          @changeNum="onChangeNum($event)"
          @changePages="onChangePages($event)"
        />
      </div>
    </form>
    <XoaVaiTroThuocNguoiDungModal
      @xoaDanhSachVaiTroThuocNguoiDung="xoaDanhSachVaiTroThuocNguoiDung"
    />
    <b-modal
      id="them-vai-tro-nguoi-dung-modal"
      size="xl"
      title="Thêm vai trò cho người dùng"
      :hide-footer="true"
    >
      <DanhSachVaiTroKhongThuocNguoiDung
        ref="danhSachVaiTroKhongThuocNguoiDung"
        @themVaiTroVaoNguoiDungThanhCong="themVaiTroVaoNguoiDungThanhCong"
        :key="`vai-tro-khong-thuoc-nguoi-dung-${nguoiDungId}`"
        :chiTietNguoiDung="chiTietNguoiDung"
        :appId="appId"
        @laydanhSachVaiTroTheoNguoiDung="layDanhSachVaiTro"
      />
    </b-modal>
  </div>
</template>

<script>
import XoaVaiTroThuocNguoiDungModal from "@/components/pages/quan-tri-he-thong/vai-tro/XoaVaiTroThuocNguoiDungModal";
import DanhSachVaiTroKhongThuocNguoiDung from "@/components/pages/quan-tri-he-thong/vai-tro/DanhSachVaiTroKhongThuocNguoiDung";
import BasePagination from "@/components/common/BasePagination";
import {
  ROUTE_NAME,
  MENU_ROUTE_NAME,
  BANG_VAI_TRO,
  BO_QUA_BUTTON_LABEL,
} from "@/constants/constants";
import { XOA_VAI_TRO_THUOC_NGUOI_DUNG_THANH_CONG } from "@/constants/message";
import _cloneDeep from "lodash/cloneDeep";
import { mapGetters } from "vuex";
import _isNil from "lodash/isNil";
import _isEmpty from "lodash/isEmpty";
import { hasPermissionUser } from "@/utils/permissionUtils";
import { PERMISSION_NAME } from "@/constants/constants";
export default {
  name: "DanhSachVaiTroTheoNguoiDung",
  components: {
    XoaVaiTroThuocNguoiDungModal,
    DanhSachVaiTroKhongThuocNguoiDung,
    BasePagination,
  },
  data() {
    return {
      PERMISSION_NAME,
      MENU_ROUTE_NAME: `${MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO}`,
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      requestInformation: {
        pageSize: 10,
        pageIndex: 1,
      },
      totalPages: 0,
      totalRows: 0,
      requestInternalForm: {},
      isLoadingTable: true,
      deletedId: null,
      nguoiDungId: null,
      danhSachIdVaiTroDaChon: [],
      danhSachIdVaiTroMuonXoa: [],
      danhSachIdVaiTro: [],
      selectAllRowsInPage: false,
      emptyHeaderTable: [
        BANG_VAI_TRO.stt,
        BANG_VAI_TRO.name,
        BANG_VAI_TRO.displayName,
        BANG_VAI_TRO.appName,
        BANG_VAI_TRO.thaoTac,
      ],
      selectedVaiTro: [],
    };
  },
  props: {
    readonly: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Boolean | null,
      required: false,
    },
    chiTietNguoiDung: {
      type: Object,
      required: true,
    },
    appId: {
      type: String,
      default: null,
    },
  },
  watch: {
    appId: {
      handler() {
        this.layDanhSachVaiTro();
      },
      deep: true,
    },
    danhSachVaiTro: {
      handler() {
        this.danhSachIdVaiTro = this.layDanhSachIdVaiTro(this.danhSachVaiTro);
        this.totalPages = this.danhSachVaiTro.totalPage;
        this.totalRows = _isNil(this.danhSachVaiTro.totalCount)
          ? 0
          : this.danhSachVaiTro.totalCount;
      },
      immediate: true,
    },
    selectAllRowsInPage: {
      handler() {
        this.clickSelectAllRowsInPage();
      },
    },
    chiTietNguoiDung: {
      handler() {
        if (!_isNil(this.chiTietNguoiDung)) {
          this.nguoiDungId = this.chiTietNguoiDung.id;
          this.layDanhSachVaiTro();
        }
      },
    },
    selectedVaiTro: {
      handler() {
        this.danhSachIdVaiTroDaChon = this.selectedVaiTro.map((x) => x.id);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      danhSachVaiTro: "user/danhSachVaiTroTheoNguoiDung",
      danhSachApp: "app/tatCaApp",
    }),
    danhSachVaiTroNoiBo() {
      return this.layDanhSachVaiTroNoiBo(this.danhSachVaiTro);
    },
    hasPageData() {
      return !_isEmpty(this.danhSachVaiTro);
    },
  },
  methods: {
    hasPermissionUser,
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachVaiTro();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
      this.layDanhSachVaiTro();
    },

    moFormThemDanhSachVaiTro() {
      this.$bvModal.show("them-vai-tro-nguoi-dung-modal");
    },

    xoaDanhSachVaiTroThuocNguoiDung() {
      const $vm = this;
      let payload = {
        userId: this.nguoiDungId,
        userCanBoDepartmentId: this.chiTietNguoiDung.userCanBoDepartmentId,
        roleIds: this.danhSachIdVaiTroMuonXoa,
        permissionIds: [],
        groupIds: [],
      };
      this.$store
        .dispatch("user/removeMapping", payload)
        .then(() => {
          $vm.$toasted.clear();
          $vm.$toasted.global.showSuccessMessage({
            message: XOA_VAI_TRO_THUOC_NGUOI_DUNG_THANH_CONG,
          });
          this.xoaVaiTroThanhCong();
        })
        .catch((error) => {
          $vm.$toasted.clear();
          if (
            !_isEmpty(error.response) &&
            error.response.data.Errors.length > 0
          ) {
            $vm.$toasted.global.showErrorMessage({
              message: error.response.data.Errors[0].Description,
            });
          }
        });
    },
    xoaVaiTroThanhCong() {
      this.danhSachIdVaiTroDaChon = [];
      this.selectedVaiTro = [];
      this.layDanhSachVaiTro();
    },
    themVaiTroVaoNguoiDungThanhCong() {
      this.$bvModal.hide("them-vai-tro-nguoi-dung-modal");
      this.layDanhSachVaiTro();
    },
    layDanhSachVaiTro() {
      if (this.chiTietNguoiDung.userCanBoDepartmentId) {
        this.isLoadingTable = true;
        const payload = {
          ...this.requestInternalForm,
          ...this.requestInformation,
          UserCanBoDepartmentId: this.chiTietNguoiDung.userCanBoDepartmentId,
          AppId: this.appId,
          UserId: this.nguoiDungId,
        };
        this.$store
          .dispatch("user/layDanhSachVaiTroTheoNguoiDung", payload)
          .then(() => {
            this.isLoadingTable = false;
          });
      } else {
        this.$store.dispatch("user/layDanhSachVaiTroTheoNguoiDung", {
          isReset: true,
        });
        this.isLoadingTable = false;
      }
    },
    layDanhSachVaiTroNoiBo(danhSachVaiTro) {
      if (_isEmpty(danhSachVaiTro)) {
        return [];
      }
      return danhSachVaiTro.items.map((item, index) => {
        return {
          checkbox: null,
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          name: _isNil(item.name) ? "" : item.name,
          displayName: _isNil(item.displayName) ? "" : item.displayName,
          appName: _isNil(item.appName) ? "" : item.appName,
          id: item.id,
          thaoTac: null,
        };
      });
    },
    layDanhSachIdVaiTro(danhSachVaiTro) {
      if (_isEmpty(danhSachVaiTro)) {
        return [];
      }
      return danhSachVaiTro.items.map((item) => item.id);
    },
    goToDetail(id) {
      this.$router.push({
        path: `${ROUTE_NAME.QUAN_TRI_HE_THONG.NAME}${ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO}/${id}/xem`,
      });
    },
    moFormXoaVaiTro(id) {
      this.danhSachIdVaiTroMuonXoa = [id];
      this.$bvModal.show("xoa-vai-tro-thuoc-nguoi-dung");
    },
    moFormXoaDanhSachVaiTro() {
      this.danhSachIdVaiTroMuonXoa = _cloneDeep(this.danhSachIdVaiTroDaChon);
      this.$bvModal.show("xoa-vai-tro-thuoc-nguoi-dung");
    },
  },
};
</script>


